import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#666",
      "fill-rule": "nonzero",
      d: "M6.999 16C4.552 16 0 12.413 0 9.021V2.55c0-.157.134-.284.3-.287l.396-.007c.015 0 1.57-.03 3.172-.654C5.512.962 6.572.227 6.583.219l.234-.163a.32.32 0 0 1 .36 0l.239.164c.01.007 1.071.742 2.714 1.381a10.3 10.3 0 0 0 3.174.655l.394.006c.165.004.299.13.299.287L14 9.023C14 12.413 9.447 16 6.998 16M12.92 3.302a11.4 11.4 0 0 1-3.182-.71 16 16 0 0 1-2.74-1.368c-.405.258-1.394.846-2.737 1.369-1.313.51-2.575.663-3.185.709v5.72c0 2.659 3.966 5.91 5.923 5.91.758 0 2.236-.605 3.689-1.934 1.4-1.28 2.236-2.767 2.236-3.976zM6.437 10.11a.54.54 0 0 1-.761 0L4.061 8.511a.53.53 0 0 1 0-.754.54.54 0 0 1 .761 0L6.058 8.98l3.119-3.09a.54.54 0 0 1 .761 0 .53.53 0 0 1 0 .755z"
    }, null, -1)
  ])))
}
export default { render: render }